module.exports = __webpack_public_path__ + "img/release-01.a7b14b5f.jpeg";